import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const frMenus = (logoUrl) => {
    const basePath = getDomainConfig(getLocale('fr-FR').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: logoUrl,
                alt: 'Raisin',
            },
        ],
        navItems: [],
        actionItems: [],
    };
};
//# sourceMappingURL=frMenus.js.map